export default "__VITE_ASSET__1fb69b7e__"